export const HELP = {
	page: 'help-page',
	faqItem: 'faq-item',
	waCta: 'help-whatsapp-cta',
	liveChat: 'help-livechat-placeholder',
	adminPage: 'admin-faqhelp-page',
	faqNewBtn: 'admin-faq-new',
	faqSaveBtn: 'admin-faq-save',
	faqRow: 'admin-faq-row',
	faqDeleteBtn: 'admin-faq-delete',
	helpSaveBtn: 'admin-help-save',
};
